import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import Layout from './components/layout/Layout';
import ProtectedRoute from './components/layout/ProtectedRoute';
import AdminRoute from './components/layout/AdminRoute';
import LoadingScreen from './components/layout/LoadingScreen';

// Pages
import Dashboard from './pages/Dashboard';
import EngageRAAH from './pages/EngageRAAH';
import Materials from './pages/Materials';
import Booking from './pages/Booking';
import Capabilities from './pages/Capabilities';
import AskQuestion from './pages/AskQuestion';
import Marketplace from './pages/Marketplace';
import Workshops from './pages/Workshops';
import Profile from './pages/Profile';
import AdminDashboard from './pages/AdminDashboard';
import MyRequests from './pages/MyRequests';
import TrackEngagement from './pages/TrackEngagement';
import NotFound from './pages/NotFound';

import { ChatProvider } from './context/ChatContext';

function App() {
  const { isLoading } = useAuth0();

  if (isLoading) return <LoadingScreen />;

  return (
    <Router>
      <ChatProvider>
      <Routes>
        {/* All routes protected */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/engage" element={<EngageRAAH />} />
            <Route path="/materials" element={<Materials />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/capabilities" element={<Capabilities />} />
            <Route path="/ask" element={<AskQuestion />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/workshops" element={<Workshops />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/my-requests" element={<MyRequests />} />
            <Route path="/my-requests/:id/track" element={<TrackEngagement />} />

            {/* Admin only */}
            <Route element={<AdminRoute />}>
              <Route path="/admin" element={<AdminDashboard />} />
            </Route>

          </Route>
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      </ChatProvider>
    </Router>
  );
}

export default App;